import { CaseStatusBadge } from '@/components/case-status-badge/case-status-badge'

interface Props {
  status: string
}

export const CellContentCaseStatus = ({ status }: Props) => {
  if (!status) {
    return '-'
  }

  return <CaseStatusBadge status={status} />
}
